'use client'

import Markdown from 'markdown-to-jsx'

import { Button } from '@/legacy-src/components/ui/button'
import { cn } from '@/legacy-src/lib/utils'
import Container from '@/legacy-src/rebrand/Container'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import Icon from '../icons/Icon'
import { usePromotionsBarChatView } from './hooks/usePromotionsBarChatView'
import { usePromotionsBarCookie } from './hooks/usePromotionsBarCookie'

// this is used to toggle the bar through css. It should neither be removed or used for styling
const PROMOTIONS_BAR_CLASS = 'hedepy-promo-bar'

export const HidePublicPromoBar = () => <style>{`.${PROMOTIONS_BAR_CLASS} { display: none!important; }`}</style>

export interface PromotionsBarProps {
  content: string
  isVisible: boolean
  isBusinessPage?: boolean
  isPromoBarHidden?: boolean
}

export const PromotionsBar = ({
  content,
  isVisible,
  isBusinessPage = false,
  isPromoBarHidden: defaultPromoBarHidden,
}: PromotionsBarProps) => {
  const { t } = getTranslate()

  const { isPromoBarHidden, hidePromoBar } = usePromotionsBarCookie({
    isPromoBarHidden: defaultPromoBarHidden,
    content,
  })

  const isChatView = usePromotionsBarChatView()

  if (isPromoBarHidden || !isVisible || !content) {
    return null
  }

  const renderButton = () => (
    <Button onClick={hidePromoBar} variant="inline" className="-m-3" aria-label={t('component.button.close')}>
      <Icon icon="cross" color={isBusinessPage ? 'pink-600' : 'primary'} size="sm" className="m-3" />
    </Button>
  )

  return (
    <div
      className={cn(
        'py-2 text-center text-base font-semibold',
        isChatView ? 'hidden tablet:flex' : 'flex',
        isBusinessPage ? 'bg-sand-500' : 'bg-blue-500',
        PROMOTIONS_BAR_CLASS,
      )}
    >
      <Container width="xl" className="flex w-full items-center justify-between gap-2">
        {/* the invisible button centers the content */}
        <div className="invisible">{renderButton()}</div>
        <Markdown
          options={{
            overrides: {
              strong: {
                props: {
                  className: 'text-peach-500 font-bold',
                },
              },
            },
          }}
        >
          {content}
        </Markdown>
        {renderButton()}
      </Container>
    </div>
  )
}
